var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.entries.length)?_c('div',{staticClass:"alert alert-info"},[_vm._v(_vm._s(_vm.$t('reporting.noDataForSelectedRange')))]):_c('e-chart',{attrs:{"option":_vm.fractionsPieChartOptions,"autoresize":""}})}
var staticRenderFns = []

export { render, staticRenderFns }